import {RemoteRefundPatchFinishRequest} from 'data/usecases';
import {PatchRefundFinishRequest} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makePatchRefundFinishRequest = (protocolCode: string): PatchRefundFinishRequest => {
	const url = RefundFlowEndPoints.request.replace(':protocolCode', protocolCode);

	return new RemoteRefundPatchFinishRequest(
		makeBFFApiUrl(url),
		makeAuthorizeHttpClientDecorator(),
	);
};
